module.exports = __webpack_public_path__ + "fonts/Jost-Bold.31ea9ec.ttf";